import { Avatar, Box, Container, Grid, Paper, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { makeStyles } from "@mui/styles";
import Helper from "../../common/Helper";
import { baseUrl } from "../../services/AzureStorage";
import BasicStatsChart from "./BasicStatsChart";
import StatsRadarChart from "./StatsRadarChart";
import { useNavigate } from "react-router-dom";
import RouteConstants from "../../common/RouteConstants";
import StatsBarChart from "./StatsBarChart";
import StatsBasicBarChart from "./StatsBasicBarChart";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: "5px 15px",
    border: "1px solid lightgrey",
    borderRadius: "10px",
    boxShadow: "2px 2px 11px grey inset",
  },
  listItemIcon: {
    minWidth: "38px",
  },
  imageIcon: {
    width: "100%",
    height: "100%",
    cursor: "pointer",
  },
  iconRoot: {
    textAlign: "center",
    width: "100%",
    height: "50px",
  },
  cardStyle: {
    border: "1px solid lightgrey",
    borderRadius: "10px",
    height: "250px",
  },

  headerText: {
    marginBottom: theme.spacing(0.5),
    color: "rgb(29, 66, 138)",
  },
  headerText2: {
    marginBottom: theme.spacing(0.5),
    color: "rgb(29, 66, 138)",
  },
  headerTextInfo: {
    color: "rgb(29, 66, 138)",
    fontSize: "14px",
  },
  headerBox: {
    background: "#c1d0ed",
    borderRadius: "17px",
  },
  smBlue: {
    marginLeft: "16px",
    width: 26,
    height: 26,
    color: theme.palette.getContrastText("#0c2c75"),
    backgroundColor: "#1e3f7e",
    position: "relative",
    overflow: "hidden",
    borderRadius: "50%",
  },
  playerNameStyle: {
    cursor: "pointer",
    "&:hover": {
      color: "blue",
    },
  },
}));
export default function BasicStats(props) {
  const classes = useStyles();
  let navigate = useNavigate();
  const {
    priamryPlayerData,
    otherPlayerData,
    groupAvg,
    perenctileRank,
    primaryName,
    eventId,
    selectedSeasons,
  } = props;

  //BAR CHART DATA HOLDERS
  const barChartLables = selectedSeasons.sort().reverse();
  const primaryPlayerDatapts = [];
  const groupAvgpts = [];
  const primaryPlayerDatareb = [];
  const groupAvgreb = [];
  const primaryPlayerDataast = [];
  const groupAvgast = [];
  const primaryPlayerDatato = [];
  const groupAvgto = [];
  const primaryPlayerDatafgper = [];
  const groupAvgafgper = [];
  const primaryPlayerData3p = [];
  const groupAvg3p = [];

  barChartLables.forEach((lable) => {
    const yearWisePlayerData = priamryPlayerData?.find(
      (data) => data.seasonYear === parseInt(lable)
    );
    const yearWiseGroupAvgData = groupAvg?.find(
      (data) => data.seasonYear === parseInt(lable)
    );

    primaryPlayerDatapts.push(yearWisePlayerData?.points || 0);
    groupAvgpts.push(yearWiseGroupAvgData?.points || 0);
    primaryPlayerDatareb.push(yearWisePlayerData?.rebounds || 0);
    groupAvgreb.push(yearWiseGroupAvgData?.rebounds || 0);
    primaryPlayerDataast.push(yearWisePlayerData?.assists || 0);
    groupAvgast.push(yearWiseGroupAvgData?.assists || 0);
    primaryPlayerDatato.push(yearWisePlayerData?.turnovers || 0);
    groupAvgto.push(yearWiseGroupAvgData?.turnovers || 0);
    primaryPlayerDatafgper.push(yearWisePlayerData?.fieldGoalsPct || 0);
    groupAvgafgper.push(yearWiseGroupAvgData?.fieldGoalsPct || 0);
    primaryPlayerData3p.push(yearWisePlayerData?.threePointsPct || 0);
    groupAvg3p.push(yearWiseGroupAvgData?.threePointsPct || 0);
  });

  var newPrimaryPlayerDatapts = [];
  var newGroupAvgpts = [];
  var newPrimaryPlayerDatareb = [];
  var newGroupAvgreb = [];
  var newPrimaryPlayerDataast = [];
  var newGroupAvgast = [];
  var newPrimaryPlayerDatato = [];
  var newGroupAvgto = [];
  var newPrimaryPlayerDatafgper = [];
  var newGroupAvgafgper = [];
  var newPrimaryPlayerData3p = [];
  var newGroupAvg3p = [];
  priamryPlayerData &&
    priamryPlayerData.map((val, index) => {
      newPrimaryPlayerDatapts.push({ x: val.points, y: val.seasonYear, r: 5 });
      newPrimaryPlayerDatareb.push({
        x: val.rebounds,
        y: val.seasonYear,
        r: 5,
      });
      newPrimaryPlayerDataast.push({ x: val.assists, y: val.seasonYear, r: 5 });
      newPrimaryPlayerDatato.push({
        x: val.turnovers,
        y: val.seasonYear,
        r: 5,
      });
      newPrimaryPlayerDatafgper.push({
        x: val.fieldGoalsPct,
        y: val.seasonYear,
        r: 5,
      });
      newPrimaryPlayerData3p.push({
        x: val.threePointsPct,
        y: val.seasonYear,
        r: 5,
      });
    });
  groupAvg &&
    groupAvg.map((val, index) => {
      newGroupAvgpts.push({ x: val.points, y: val.seasonYear, r: 5 });
      newGroupAvgreb.push({ x: val.rebounds, y: val.seasonYear, r: 5 });
      newGroupAvgast.push({ x: val.assists, y: val.seasonYear, r: 5 });
      newGroupAvgto.push({ x: val.turnovers, y: val.seasonYear, r: 5 });
      newGroupAvgafgper.push({ x: val.fieldGoalsPct, y: val.seasonYear, r: 5 });
      newGroupAvg3p.push({ x: val.threePointsPct, y: val.seasonYear, r: 5 });
    });
  const labels = ["PTS", "AST", "REB", "TO", "FG%", "3P%", "FT%"];
  const data = [];
  const otherPlayerdata = []; // [10,20,30,40,50,60,70];
  perenctileRank.map((val, index) => {
    if (
      val.category === "PTS" ||
      val.category === "AST" ||
      val.category === "REB" ||
      val.category === "TO" ||
      val.category === "FG%" ||
      val.category === "3P%" ||
      val.category === "FT%"
    ) {
      data.push(val.primaryPlayerPercentile);
      otherPlayerdata.push(val.groupPercentile);
    }
  });

  const viewPlayerProfile = (playerId) => {
    navigate(`/${eventId}${RouteConstants.VIEW_PLAYER_PROFILE}/${playerId}`, {
      state: { from: "CareerStats", tab: 0 },
    });
  };

  return (
    <Container maxWidth={false}>
      <Box mt={2} mb={2}>
        <Paper elevation={2} sx={{ p: 2 }}>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            className={classes.headerBox}
          >
            <Box display="flex" pl={2}>
              <Typography className={`${classes.headerText} headerTitle`}>
                Selected Player
              </Typography>
            </Box>
          </Box>
          <Grid container spacing={2} pt={3}>
            <TableContainer>
              {priamryPlayerData && priamryPlayerData.length > 0 && (
                <Table>
                  <TableHead>
                    <TableCell style={{ padding: "4px", paddingLeft: "25px" }}>
                      Player Name
                    </TableCell>
                    <TableCell style={{ padding: "4px" }}>Position</TableCell>
                    <TableCell style={{ padding: "4px" }}>Season</TableCell>
                    <TableCell style={{ padding: "4px" }}>GP</TableCell>
                    <TableCell style={{ padding: "4px" }}>GS</TableCell>
                    <TableCell style={{ padding: "4px" }}>MIN</TableCell>
                    <TableCell style={{ padding: "4px" }}>FGM</TableCell>
                    <TableCell style={{ padding: "4px" }}>FGA</TableCell>
                    <TableCell style={{ padding: "4px" }}>FG%</TableCell>
                    <TableCell style={{ padding: "4px" }}>2PM</TableCell>
                    <TableCell style={{ padding: "4px" }}>2PA</TableCell>
                    <TableCell style={{ padding: "4px" }}>2P%</TableCell>
                    <TableCell style={{ padding: "4px" }}>3PM</TableCell>
                    <TableCell style={{ padding: "4px" }}>3PA</TableCell>
                    <TableCell style={{ padding: "4px" }}>3P%</TableCell>
                    <TableCell style={{ padding: "4px" }}>FTM</TableCell>
                    <TableCell style={{ padding: "4px" }}>FTA</TableCell>
                    <TableCell style={{ padding: "4px" }}>FT%</TableCell>
                    <TableCell style={{ padding: "4px" }}>ORB</TableCell>
                    <TableCell style={{ padding: "4px" }}>DRB</TableCell>
                    <TableCell style={{ padding: "4px" }}>REB</TableCell>
                    <TableCell style={{ padding: "4px" }}>AST</TableCell>
                    <TableCell style={{ padding: "4px" }}>TO</TableCell>
                    <TableCell style={{ padding: "4px" }}>STL</TableCell>
                    <TableCell style={{ padding: "4px" }}>BLK</TableCell>
                    <TableCell style={{ padding: "4px" }}>PF</TableCell>
                    <TableCell style={{ padding: "4px" }}>TF</TableCell>
                    <TableCell style={{ padding: "4px" }}>PTS</TableCell>
                    <TableCell style={{ padding: "4px" }}>FF</TableCell>
                    <TableCell style={{ padding: "4px" }}>TS%</TableCell>
                  </TableHead>

                  <TableBody>
                    {priamryPlayerData.length > 0
                      ? priamryPlayerData.map((val, index) => {
                          return (
                            <TableRow key={index}>
                              <TableCell style={{ padding: "5px" }}>
                                <Box display="flex">
                                  {val.headshotURL && val.headshotURL !== "" ? (
                                    <Avatar
                                      className={classes.smBlue}
                                      sx={{
                                        bgcolor: "#1d428a",
                                        cursor: "pointer",
                                      }}
                                      src={
                                        val.headshotURL
                                          ? baseUrl(val.headshotURL)
                                          : ""
                                      }
                                      alt="basketball"
                                      title="View Player Profile"
                                      onClick={() =>
                                        viewPlayerProfile(val.playerID)
                                      }
                                    >
                                      <Typography variant="caption">
                                        {Helper.GetNameInitials(
                                          `${val.playerName}`
                                        )}
                                      </Typography>
                                    </Avatar>
                                  ) : (
                                    <Avatar
                                      className={classes.smBlue}
                                      sx={{
                                        bgcolor: "#1d428a",
                                        cursor: "pointer",
                                      }}
                                      alt="basketball"
                                      title="View Player Profile"
                                      onClick={() =>
                                        viewPlayerProfile(val.playerID)
                                      }
                                    >
                                      <Typography variant="caption">
                                        {Helper.GetNameInitials(
                                          `${val.playerName}`
                                        )}
                                      </Typography>
                                    </Avatar>
                                  )}
                                  &nbsp;&nbsp;
                                  <Typography
                                    variant="body2"
                                    className={classes.playerNameStyle}
                                    title="View Player Profile"
                                    onClick={() =>
                                      viewPlayerProfile(val.playerID)
                                    }
                                  >
                                    {val.playerName}
                                  </Typography>
                                </Box>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                {
                                  <Typography variant="caption">
                                    {val.position ? val.position : "-"}
                                  </Typography>
                                }
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.seasonYear ? val.seasonYear : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {val.gamesPlayed ? val.gamesPlayed : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.gamesStarted ? val.gamesStarted : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.minutes ? val.minutes : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.fieldGoalsMade
                                    ? val.fieldGoalsMade
                                    : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.fieldGoalsAtt ? val.fieldGoalsAtt : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.fieldGoalsPct
                                    ? parseInt(val.fieldGoalsPct * 100)
                                    : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.twoPointsMade ? val.twoPointsMade : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.twoPointsAtt ? val.twoPointsAtt : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.twoPointsPct
                                    ? parseInt(val.twoPointsPct * 100)
                                    : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.threePointsMade
                                    ? val.threePointsMade
                                    : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.threePointsAtt
                                    ? val.threePointsAtt
                                    : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.threePointsPct
                                    ? parseInt(val.threePointsPct * 100)
                                    : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.freeThrowsMade
                                    ? val.freeThrowsMade
                                    : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.freeThrowsAtt ? val.freeThrowsAtt : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.freeThrowsPct
                                    ? parseInt(val.freeThrowsPct * 100)
                                    : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.offensiveRebounds
                                    ? val.offensiveRebounds
                                    : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.defensiveRebounds
                                    ? val.defensiveRebounds
                                    : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.rebounds ? val.rebounds : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.assists ? val.assists : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.turnovers ? val.turnovers : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.steals ? val.steals : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.blocks ? val.blocks : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.personalFouls ? val.personalFouls : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.techFouls ? val.techFouls : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.points ? val.points : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.flagrantFouls ? val.flagrantFouls : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.trueShootingPct
                                    ? parseInt(val.trueShootingPct * 100)
                                    : "-"}
                                </Typography>
                              </TableCell>
                            </TableRow>
                          );
                        })
                      : null}
                  </TableBody>
                </Table>
              )}
            </TableContainer>
          </Grid>
        </Paper>
      </Box>

      <Box mt={2} mb={2}>
        <Paper elevation={2} sx={{ p: 2 }}>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            className={classes.headerBox}
          >
            <Box display="flex" pl={2}>
              <Typography className={`${classes.headerText} headerTitle`}>
                Comparison Group
              </Typography>
            </Box>
          </Box>
          <Grid container spacing={2} pt={3}>
            {/* <TableContainer> */}
            <Paper className="scrollTable">
              {otherPlayerData && otherPlayerData.length > 0 && (
                <Table>
                  <TableHead>
                    <TableCell style={{ padding: "4px", paddingLeft: "25px" }}>
                      Player Name
                    </TableCell>
                    <TableCell style={{ padding: "4px" }}>Position</TableCell>
                    <TableCell style={{ padding: "4px" }}>Season</TableCell>
                    <TableCell style={{ padding: "4px" }}>GP</TableCell>
                    <TableCell style={{ padding: "4px" }}>GS</TableCell>
                    <TableCell style={{ padding: "4px" }}>MIN</TableCell>
                    <TableCell style={{ padding: "4px" }}>FGM</TableCell>
                    <TableCell style={{ padding: "4px" }}>FGA</TableCell>
                    <TableCell style={{ padding: "4px" }}>FG%</TableCell>
                    <TableCell style={{ padding: "4px" }}>2PM</TableCell>
                    <TableCell style={{ padding: "4px" }}>2PA</TableCell>
                    <TableCell style={{ padding: "4px" }}>2P%</TableCell>
                    <TableCell style={{ padding: "4px" }}>3PM</TableCell>
                    <TableCell style={{ padding: "4px" }}>3PA</TableCell>
                    <TableCell style={{ padding: "4px" }}>3P%</TableCell>
                    <TableCell style={{ padding: "4px" }}>FTM</TableCell>
                    <TableCell style={{ padding: "4px" }}>FTA</TableCell>
                    <TableCell style={{ padding: "4px" }}>FT%</TableCell>
                    <TableCell style={{ padding: "4px" }}>ORB</TableCell>
                    <TableCell style={{ padding: "4px" }}>DRB</TableCell>
                    <TableCell style={{ padding: "4px" }}>REB</TableCell>
                    <TableCell style={{ padding: "4px" }}>AST</TableCell>
                    <TableCell style={{ padding: "4px" }}>TO</TableCell>
                    <TableCell style={{ padding: "4px" }}>STL</TableCell>
                    <TableCell style={{ padding: "4px" }}>BLK</TableCell>
                    <TableCell style={{ padding: "4px" }}>PF</TableCell>
                    <TableCell style={{ padding: "4px" }}>TF</TableCell>
                    <TableCell style={{ padding: "4px" }}>PTS</TableCell>
                    <TableCell style={{ padding: "4px" }}>FF</TableCell>
                    <TableCell style={{ padding: "4px" }}>TS%</TableCell>
                  </TableHead>
                  <TableBody>
                    {otherPlayerData.length > 0
                      ? otherPlayerData.map((val, index) => {
                          var avg = false;
                          if (val.playerName === "AVG") {
                            avg = true;
                          }
                          return (
                            <TableRow
                              key={index}
                              sx={{
                                backgroundColor: avg ? "#F5F5F5" : "white",
                              }}
                            >
                              <TableCell style={{ padding: "5px" }}>
                                {avg ? (
                                  ""
                                ) : (
                                  <Box display="flex">
                                    {val.headshotURL &&
                                    val.headshotURL !== "" ? (
                                      <Avatar
                                        className={classes.smBlue}
                                        sx={{
                                          bgcolor: "#1d428a",
                                          cursor: "pointer",
                                        }}
                                        src={
                                          val.headshotURL
                                            ? baseUrl(val.headshotURL)
                                            : ""
                                        }
                                        alt="basketball"
                                        title="View Player Profile"
                                        onClick={() =>
                                          viewPlayerProfile(val.playerID)
                                        }
                                      >
                                        <Typography variant="caption">
                                          {Helper.GetNameInitials(
                                            `${val.playerName}`
                                          )}
                                        </Typography>
                                      </Avatar>
                                    ) : (
                                      <Avatar
                                        className={classes.smBlue}
                                        sx={{
                                          bgcolor: "#1d428a",
                                          cursor: "pointer",
                                        }}
                                        alt="basketball"
                                        title="View Player Profile"
                                        onClick={() =>
                                          viewPlayerProfile(val.playerID)
                                        }
                                      >
                                        <Typography variant="caption">
                                          {Helper.GetNameInitials(
                                            `${val.playerName}`
                                          )}
                                        </Typography>
                                      </Avatar>
                                    )}
                                    &nbsp;&nbsp;
                                    <Typography
                                      variant="body2"
                                      className={classes.playerNameStyle}
                                      title="View Player Profile"
                                      onClick={() =>
                                        viewPlayerProfile(val.playerID)
                                      }
                                    >
                                      {val.playerName}
                                    </Typography>
                                  </Box>
                                )}
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                {avg ? (
                                  ""
                                ) : (
                                  <Typography variant="caption">
                                    {val.position ? val.position : "-"}
                                  </Typography>
                                )}
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.seasonYear ? val.seasonYear : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {val.gamesPlayed ? val.gamesPlayed : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.gamesStarted ? val.gamesStarted : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.minutes ? val.minutes : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.fieldGoalsMade
                                    ? val.fieldGoalsMade
                                    : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.fieldGoalsAtt ? val.fieldGoalsAtt : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.fieldGoalsPct
                                    ? parseInt(val.fieldGoalsPct * 100)
                                    : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.twoPointsMade ? val.twoPointsMade : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.twoPointsAtt ? val.twoPointsAtt : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.twoPointsPct
                                    ? parseInt(val.twoPointsPct * 100)
                                    : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.threePointsMade
                                    ? val.threePointsMade
                                    : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.threePointsAtt
                                    ? val.threePointsAtt
                                    : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.threePointsPct
                                    ? parseInt(val.threePointsPct * 100)
                                    : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.freeThrowsMade
                                    ? val.freeThrowsMade
                                    : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.freeThrowsAtt ? val.freeThrowsAtt : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.freeThrowsPct
                                    ? parseInt(val.freeThrowsPct * 100)
                                    : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.offensiveRebounds
                                    ? val.offensiveRebounds
                                    : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.defensiveRebounds
                                    ? val.defensiveRebounds
                                    : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.rebounds ? val.rebounds : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.assists ? val.assists : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.turnovers ? val.turnovers : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.steals ? val.steals : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.blocks ? val.blocks : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.personalFouls ? val.personalFouls : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.techFouls ? val.techFouls : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.points ? val.points : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.flagrantFouls ? val.flagrantFouls : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell style={{ padding: "4px" }}>
                                <Typography variant="caption">
                                  {" "}
                                  {val.trueShootingPct
                                    ? parseInt(val.trueShootingPct * 100)
                                    : "-"}
                                </Typography>
                              </TableCell>
                            </TableRow>
                          );
                        })
                      : null}
                  </TableBody>
                </Table>
              )}

              {/* </TableContainer> */}
            </Paper>
          </Grid>
        </Paper>
      </Box>
      <Grid container spacing={2}>
        <Grid item md={6} sm={12} xs={12} justifyContent="center">
          {perenctileRank.length > 0 ? (
            <StatsRadarChart
              labels={labels}
              data={data}
              name={primaryName}
              otherPlayerdata={otherPlayerdata}
              nameotherplayer={"Comparison Group"}
            />
          ) : (
            ""
          )}
        </Grid>
        <Grid item md={6} sm={12} xs={12} justifyContent="center">
          {perenctileRank.length > 0 ? (
            <StatsBasicBarChart
              labels={labels}
              priamryPlayerData={data}
              primaryPlayerName={primaryName}
              otherPlayerdata={otherPlayerdata}
              nameOtherPlayer={"Comparison Group"}
              chartName={""}
            />
          ) : (
            ""
          )}
        </Grid>
      </Grid>
      {/* ==================== BAR CHART ========================= */}
      <Grid container spacing={2}>
        <Grid item md={6} sm={12} xs={12}>
          {primaryPlayerDatapts?.length > 0 && priamryPlayerData?.length > 0 ? (
            <StatsBarChart
              priamryPlayerData={primaryPlayerDatapts}
              groupAvg={groupAvgpts}
              chartName={"PTS"}
              name={primaryName}
              labels={barChartLables}
            />
          ) : null}
        </Grid>
        <Grid item md={6} sm={12} xs={12}>
          {primaryPlayerDatareb?.length > 0 && priamryPlayerData?.length > 0 ? (
            <StatsBarChart
              priamryPlayerData={primaryPlayerDatareb}
              groupAvg={groupAvgreb}
              chartName={"REB"}
              name={primaryName}
              labels={barChartLables}
            />
          ) : null}
        </Grid>
        <Grid item md={6} sm={12} xs={12}>
          {primaryPlayerDataast?.length > 0 && priamryPlayerData?.length > 0 ? (
            <StatsBarChart
              priamryPlayerData={primaryPlayerDataast}
              groupAvg={groupAvgast}
              chartName={"AST"}
              name={primaryName}
              labels={barChartLables}
            />
          ) : null}
        </Grid>
        <Grid item md={6} sm={12} xs={12}>
          {primaryPlayerDatato?.length > 0 && priamryPlayerData?.length > 0 ? (
            <StatsBarChart
              priamryPlayerData={primaryPlayerDatato}
              groupAvg={groupAvgto}
              chartName={"TO"}
              name={primaryName}
              labels={barChartLables}
            />
          ) : null}
        </Grid>{" "}
        <Grid item md={6} sm={12} xs={12}>
          {primaryPlayerDatafgper?.length > 0 &&
          priamryPlayerData?.length > 0 ? (
            <StatsBarChart
              priamryPlayerData={primaryPlayerDatafgper}
              groupAvg={groupAvgafgper}
              chartName={"FG%"}
              name={primaryName}
              labels={barChartLables}
            />
          ) : null}
        </Grid>
        <Grid item md={6} sm={12} xs={12}>
          {primaryPlayerData3p?.length > 0 && priamryPlayerData?.length > 0 ? (
            <StatsBarChart
              priamryPlayerData={primaryPlayerData3p}
              groupAvg={groupAvg3p}
              chartName={"3P%"}
              name={primaryName}
              labels={barChartLables}
            />
          ) : null}
        </Grid>
      </Grid>
      {/* ==================== BAR CHART ========================= */}
      {/* <Grid container spacing={2}>
        <Grid item md={6} sm={12} xs={12} justifyContent="center">
          {newPrimaryPlayerDatapts.length > 0 &&
          priamryPlayerData.length > 0 ? (
            <BasicStatsChart
              priamryPlayerData={newPrimaryPlayerDatapts}
              groupAvg={newGroupAvgpts}
              chartName={"PTS"}
              name={primaryName}
            />
          ) : null}
        </Grid>
        <Grid item md={6} sm={12} xs={12}>
          {newPrimaryPlayerDatareb.length > 0 ? (
            <BasicStatsChart
              priamryPlayerData={newPrimaryPlayerDatareb}
              groupAvg={newGroupAvgreb}
              chartName={"REB"}
              name={primaryName}
            />
          ) : null}
        </Grid>
        <Grid item md={6} sm={12} xs={12}>
          {newPrimaryPlayerDataast.length > 0 ? (
            <BasicStatsChart
              priamryPlayerData={newPrimaryPlayerDataast}
              groupAvg={newGroupAvgast}
              chartName={"AST"}
              name={primaryName}
            />
          ) : null}
        </Grid>
        <Grid item md={6} sm={12} xs={12}>
          {newPrimaryPlayerDatato.length > 0 ? (
            <BasicStatsChart
              priamryPlayerData={newPrimaryPlayerDatato}
              groupAvg={newGroupAvgto}
              chartName={"TO"}
              name={primaryName}
            />
          ) : null}
        </Grid>{" "}
        <Grid item md={6} sm={12} xs={12}>
          {newPrimaryPlayerDatafgper.length > 0 ? (
            <BasicStatsChart
              priamryPlayerData={newPrimaryPlayerDatafgper}
              groupAvg={newGroupAvgafgper}
              chartName={"FG%"}
              name={primaryName}
            />
          ) : null}
        </Grid>
        <Grid item md={6} sm={12} xs={12}>
          {newPrimaryPlayerData3p.length > 0 ? (
            <BasicStatsChart
              priamryPlayerData={newPrimaryPlayerData3p}
              groupAvg={newGroupAvg3p}
              chartName={"3P%"}
              name={primaryName}
            />
          ) : null}
        </Grid>
      </Grid> */}

      {/* <Loader isLoading={loading} /> */}
    </Container>
  );
}
